import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=55edc05f&scoped=true&"
import script from "./cards.vue?vue&type=script&lang=js&"
export * from "./cards.vue?vue&type=script&lang=js&"
import style0 from "./cards.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cards.vue?vue&type=style&index=1&id=55edc05f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edc05f",
  null
  
)

export default component.exports